var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailsField',_vm._b({},'DetailsField',_vm.$attrs,false),[_c('AeAddress',{attrs:{"address":_vm.address}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }